import { SOURCE } from "@/constants";
import { Episode } from "@/types/Episode";

const formatSocialMediaUser = (name: string) => `@${name}`;

export const getShowName = (episode: Pick<Episode, "show" | "source">) => {
  const { show, source } = episode;

  if (!show && source === SOURCE.INSTAGRAM) {
    return L.PUBLIC_MENTION_UNKNOWN_INSTAGRAM_USER;
  } else if (
    source === SOURCE.INSTAGRAM ||
    source === SOURCE.TIKTOK ||
    source === SOURCE.TWITTER
  ) {
    return formatSocialMediaUser(show);
  } else {
    return show;
  }
};
